import { PurchaseCompleteDialog } from './PurchaseCompleteDialog';
import { usePurchaseCompleteListener } from '../hooks/use-purchase-complete-listener';
import { usePurchaseCompleteStore } from '../store/purchase-complete.store';

export const PurchaseCompleteListener = () => {
  usePurchaseCompleteListener();
  const payload = usePurchaseCompleteStore((state) => state.payload);
  const dismiss = usePurchaseCompleteStore((state) => state.dismiss);

  return <PurchaseCompleteDialog open={!!payload} payload={payload} onClose={dismiss} />;
};
